import Button from "@mlb/react-patterns/dist/components/Button/button";
import { Label } from "@mlb/react-patterns/dist/components/Button/button.style";
import { ButtonShapes, ButtonStyles } from "@mlb/react-patterns/dist/components/Button/button.types";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import styled from "styled-components";
var favoriteYellow = COLORS.favoriteYellow,
  mlbBlack = COLORS.mlbBlack;
export var TeamFilterRowContainer = styled(Button).attrs({
  hasHover: false,
  iconColor: mlbBlack,
  iconLeft: false,
  iconName: "arrow-next",
  iconSize: 18,
  shape: ButtonShapes.HOLLOW_BORDERLESS,
  styleName: ButtonStyles.GREY
}).withConfig({
  displayName: "styles__TeamFilterRowContainer",
  componentId: "sc-jki774-0"
})(["align-items:center;border-radius:0;display:flex;height:100%;justify-content:space-between;padding:0;text-align:left;width:100%;&[data-focus-visible-added]{background:none;box-shadow:inset 0 0 0 3px rgba(0,137,255,0.65);outline:none;}&:hover{background:", "0D;}", " svg{fill:", ";path{fill:", ";}}"], mlbBlack, Label, favoriteYellow, favoriteYellow);